import StrAboutDescription from "<str-about-description>";
import StrBusinessDetails from "<str-business-details>";
import StrMarketingBanner from "<str-marketing-banner>";
import StrContactSeller from "<str-contact-seller>";
import StrItemsCarousel from "<str-items-carousel>";
import StrAboutPolicies from "<str-about-policies>";
import StrSellerComms from "<str-seller-comms>";
import StrAboutVideo from "<str-about-video>";
import StrItemsGrid from "<str-items-grid>";
import StrStatusModule from "<str-status>";
import StrDebug from "<str-debug>";

$ {
    const moduleComponents = {
        StrAboutDescription,
        StrBusinessDetails,
        StrMarketingBanner,
        StrContactSeller,
        StrItemsCarousel,
        StrAboutPolicies,
        StrStatusModule,
        StrSellerComms,
        StrAboutVideo,
        StrItemsGrid
    };
    const modulesRequiringFullRegions = [
        "StrAboutPolicies",
        "StrAboutVideo",
        "StrItemsGrid"
    ];
    const region = input.regionsData[input.region];
}

<if(region)>
    <for|module| of=region>
        <if(module)>
            <${module.__debug && StrDebug}
                __empty=!moduleComponents[module._uxComponent]
                module=module
            >
                <if(moduleComponents[module._uxComponent])>
                    $ {
                        const passedInput = modulesRequiringFullRegions
                            .find(component => component === module._uxComponent)
                                ? { regionsData: input.regionsData }
                                : module;
                    }
                    <${moduleComponents[module._uxComponent]} ...passedInput />
                </if>
            </>
        </if>
    </for>
</if>
